const ChrPropTypes = {
  array: "ARRAY",
  object: "OBJECT",
  string: "STRING",
  bool: "BOOL",
  number: "NUMBER"
}
export default ChrPropTypes;